import React from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.setItem("userState", 0);
    navigate("/login");
  };

  return (
    <button className="btn btn-white logout-btn" onClick={handleLogout}>
      Logout
    </button>
  );
};

export default Logout;
